import { Table } from '@/components/maintenance_schedule/table'

export const MaintenanceSchedules = () => {
  return (
    <>
      <Table createable onIndex />
    </>
  )
}
